<template>
  <v-dialog v-model="get_MainProgressDialog.dialog"
    :max-width="get_MainProgressDialog.with" persistent>
    <v-list class="py-2" color="secondary" elevation="12">
      <v-list-item>
        <v-list-item-icon>
          <v-icon>{{ get_MainProgressDialog.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ get_MainProgressDialog.title }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-progress-circular color="primary" indeterminate size="20"></v-progress-circular>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-dialog>
</template>
<script>

import { mapGetters, mapMutations } from 'vuex'
export default {
  data: () => ({
  }),
  components: {},
  computed: {
    ...mapGetters(['get_MainProgressDialog'])
  },
  methods: {
    ...mapMutations(['HIDDEN_MAIN_PROGRESS_DIALOG'])
  }
}
</script>
<style scoped>
</style>
